module.exports = __webpack_public_path__ + "img/fourday_ps_28.132fcb2d.jpg";